import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/userprofile/successImg.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";
import { axiosInstance_user } from "../../axiosInstance-user";
import CircularProgress from "@mui/material/CircularProgress"; 
import { ToastContainer, toast } from "react-toastify";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
export function FamilyInfo() {
    const [loading, setLoading] = useState(false);
  const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
const formik = useFormik({
  initialValues: {
    father_name: "",
    mother_name: "",
    father_occupation: "",
    mother_occupation: "",
    total_brothers: "",
    total_sisters: "",
    total_brothers_married: "",
    total_sisters_married: "",
    family_type: "",
    family_style: "",
    mother_is_alive: false,
    father_is_alive: false,
  },

  enableReinitialize: true,

  onSubmit: async (values) => {
    try {
      setLoading(true);
      console.log("EditUser", values);

      const formData = new FormData();

      // Append fields under profile
      formData.append("profile[father_name]", values.father_name || "");
      formData.append("profile[mother_name]", values.mother_name || "");
      formData.append("profile[father_occupation]", values.father_occupation || "");
      formData.append("profile[mother_occupation]", values.mother_occupation || "");
      formData.append("profile[total_brothers]", values.total_brothers || 0);
      formData.append("profile[total_sisters]", values.total_sisters || 0);
      formData.append("profile[total_brothers_married]", values.total_brothers_married || 0);
      formData.append("profile[total_sisters_married]", values.total_sisters_married || 0);
      formData.append("profile[mother_is_alive]", values.mother_is_alive ? "true" : "false");
      formData.append("profile[father_is_alive]", values.father_is_alive ? "true" : "false");
      formData.append("profile[family_type]", Number(values.family_type));
      formData.append("profile[family_style]", Number(values.family_style));

      const response = await axiosInstance_user.patch(
        `/users-profiles/${userId}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === "success") {
        setLoading(false); // Stop loader
        handleOpen(); // Success action
         setTimeout(() => {
            handleClose();
          },2000);
          LoadUserProfile(userId);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "");
      console.error("Error while updating", error);
    }
    finally {
        setLoading(false);
      }
  },
});
const [profileData, setProfileData] = useState(null);

  // get user data
 async function LoadUserProfile(userId) {
  try {
    const response = await axiosInstance_user.get(`/users-profiles/${userId}`);
    if (response.data.status === "success") {
      const profile = response.data.data.profile;
      setProfileData(profile);  //  save here instead of setting values
    }
  } catch (err) {
    console.error("Failed to load profile:", err);
  }
}
useEffect(() => {
  if (userId) {
    LoadUserProfile(userId);
  }
}, [userId]);

useEffect(() => {
  if (profileData) {
    formik.setValues({
      father_name: profileData.father_name || "",
      mother_name: profileData.mother_name || "",
      father_occupation: profileData.father_occupation || "",
      mother_occupation: profileData.mother_occupation || "",
      total_brothers: profileData.total_brothers || "",
      total_sisters: profileData.total_sisters || "",
      total_brothers_married: profileData.total_brothers_married || "",
      total_sisters_married: profileData.total_sisters_married || "",
      family_type: profileData.family_type || "",
      family_style: profileData.family_style || "",
      mother_is_alive: profileData.mother_is_alive ?? false,
      father_is_alive: profileData.father_is_alive ?? false,
    });
  }
}, [profileData]);

  return (
    <form onSubmit={formik.handleSubmit}>
       {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div>
        {/* row1 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Father Name 
            </div>
            <div className="family-input">
              <input
                type="text"
                name="father_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.father_name}
                placeholder="Enter Father Name"
              />
              {formik.touched.father_name && formik.errors.father_name && (
                <div className="text-danger">{formik.errors.father_name}</div>
              )}
            </div>
          </div>
          <div>
            <div className="family-label">
              Mother Name 
            </div>
            <div className="family-input">
              <input
                type="text"
                name="mother_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.mother_name}
                placeholder="Enter Mother Name"
              />
              {formik.touched.mother_name && formik.errors.mother_name && (
                <div className="text-danger">{formik.errors.mother_name}</div>
              )}
            </div>
          </div>
        </div>

        {/* row2 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Father Occupation
            </div>
            <div className="family-input">
              <input
                type="text"
                name="father_occupation"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.father_occupation}
                placeholder="Enter Father Occupation"
              />
              {formik.touched.father_occupation &&
                formik.errors.father_occupation && (
                  <div className="text-danger">
                    {formik.errors.father_occupation}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="family-label">
              Mother Occupation
            </div>
            <div className="family-input">
              <input
                type="text"
                name="mother_occupation"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.mother_occupation}
                placeholder="Enter Mother Occupation"
              />
              {formik.touched.mother_occupation &&
                formik.errors.mother_occupation && (
                  <div className="text-danger">
                    {formik.errors.mother_occupation}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* row3 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Total Brothers 
            </div>
            <div className="family-input">
              <input
                type="number"
                name="total_brothers"
                min="0"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.total_brothers}
              />
              {formik.touched.total_brothers &&
                formik.errors.total_brothers && (
                  <div className="text-danger">
                    {formik.errors.total_brothers}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="family-label">
              Total Sisters 
            </div>
            <div className="family-input">
              <input
                type="number"
                min="0"
                name="total_sisters"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.total_sisters}
              />
              {formik.touched.total_sisters && formik.errors.total_sisters && (
                <div className="text-danger">{formik.errors.total_sisters}</div>
              )}
            </div>
          </div>
        </div>

        {/* row4 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Total Brothers Married 
            </div>
            <div className="family-input">
              <input
                type="number"
                min="0"
                name="total_brothers_married"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.total_brothers_married}
              />
              {formik.touched.total_brothers_married &&
                formik.errors.total_brothers_married && (
                  <div className="text-danger">
                    {formik.errors.total_brothers_married}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="family-label">
              Total Sisters Married 
            </div>
            <div className="family-input">
              <input
                type="number"
                min="0"
                name="total_sisters_married"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.total_sisters_married}
              />
              {formik.touched.total_sisters_married &&
                formik.errors.total_sisters_married && (
                  <div className="text-danger">
                    {formik.errors.total_sisters_married}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* row5 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Family Type
            </div>
            <select
              className="dropdown-btnFamily"
              name="family_type"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.family_type}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Nuclear Family</option>
              <option value="2">Joint Family</option>
              <option value="3">Single Parent Family</option>
              <option value="4">Extended Family</option>
              <option value="5">Blended Family</option>
              <option value="6">Adoptive Family</option>
              <option value="7">Other</option>
            </select>
            {formik.touched.family_type && formik.errors.family_type && (
              <div className="text-danger">{formik.errors.family_type}</div>
            )}
          </div>
          <div>
            <div className="family-label">
              Family Style
            </div>
            <select
              className="dropdown-btnFamily"
              name="family_style"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.family_style}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="1">South Indian</option>
              <option value="2">North Indian</option>
              <option value="3">Others</option>
            </select>
            {formik.touched.family_style && formik.errors.family_style && (
              <div className="text-danger">{formik.errors.family_style}</div>
            )}
          </div>
        </div>

        {/* row6 */}
        <div className="family-subcontainer">
          <div>
            <input
              type="checkbox"
              name="mother_is_alive"
              onChange={(e) =>
                formik.setFieldValue("mother_is_alive", e.target.checked)
              }
              checked={formik.values.mother_is_alive === true}
            />
            <label className="family-label">Mother is Alive</label>
            <div>
              {formik.touched.mother_is_alive &&
                formik.errors.mother_is_alive && (
                  <div className="text-danger">
                    {formik.errors.mother_is_alive}
                  </div>
                )}
            </div>
          </div>
          <div>
            <input
              type="checkbox"
              name="father_is_alive"
              onChange={(e) =>
                formik.setFieldValue("father_is_alive", e.target.checked)
              }
              checked={formik.values.father_is_alive === true}
            />
            <label className="family-label">Father is Alive</label>
            <div>
              {formik.touched.father_is_alive &&
                formik.errors.father_is_alive && (
                  <div className="text-danger">
                    {formik.errors.father_is_alive}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* Save Button */}
        <div className="btnBasicSave">
          <Button type="submit">Save Changes</Button>
        </div>

        {/* Modal */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="success" />
              <Typography variant="h6" component="h2">
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
               Family information has been updated successfully 
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
